import create from "zustand";
import { produce } from "immer";

export interface ENTReportState {
  EarReportData: {
    clinicalEntExamination: ClinicalENTExamination;
  };
  ENTMetaData: ENTMetaData;
  ENTOtherData: ENTOtherProps;
  NoseData: NoseProps;
  ThroatData: ThroatProps;
  NeckData: NeckProps;
  ENT_Suggested_Investigation_Data: EntSuggestedInvestigation;
  NeedAttention: ENTNeedAttentionProps;
  // Actions
  setENTReportData: (data: Record<string, string>) => void;
  resetENTReport: () => void;
}

const INITIAL_DATA = {
  EarReportData: {
    clinicalEntExamination: {
      rightEar: {
        Right_Ear_Discharge: false,
        Right_Ear_Ear_Wax: false,
        Right_Ear_Malformation: false,
        Right_Ear_Pain: false,
        Right_Ear_Tinnitus: false,
      },
      leftEar: {
        Left_Ear_Discharge: false,
        Left_Ear_Ear_Wax: false,
        Left_Ear_Malformation: false,
        Left_Ear_Pain: false,
        Left_Ear_Tinnitus: false,
      },
    },
  },
  ENTMetaData: {
    ENT_Doctor_No: "",
    ENT_Doctor_Designation: "",
    ENT_Doctor_Hospital: "",
    ENT_Doctor_Path: "",
    ENT_Doctor_Remarks: "",
  },
  ENTOtherData: {
    Left_Ear_Others: "",
    Right_Ear_Others: "",
    Nose_Others: "",
    Oral_Cavity_Throat_Others: "",
    Neck_Others: "",
    ENT_Other_Tests: "",
  },
  NoseData: {
    Nose_Nasal_Polyp: false,
    Nose_Deviated_Nasal_Septum: false,
    Nose_Sinus_Tenderness: false,
    Nose_Discharge: false,
  },
  ThroatData: {
    Oral_Cavity_Throat_Cheilitis: false,
    Oral_Cavity_Throat_Oral_Thrush: false,
    Oral_Cavity_Throat_Pain: false,
    Oral_Cavity_Throat_Tonsillopharyngitis: false,
    Oral_Cavity_Throat_Tonsils: false,
    Oral_Cavity_Throat_Adenoids: false,
  },
  NeckData: {
    Neck_Cyst: false,
    Neck_Thyroid_Swelling: false,
  },
  ENT_Suggested_Investigation_Data: {
    ENT_Doctor_Consultation: false,
    HSG_ENT_Doctor_Consultation: false,
  },
  NeedAttention: {
    rightEar: false,
    leftEar: false,
    nose: false,
    throat: false,
    neck: false,
    suggestedInvestigation: false,
  },
};

export const useENTStore = create<ENTReportState>((set) => ({
  ...INITIAL_DATA,

  setENTReportData: (responseData) =>
    set(
      produce((state: ENTReportState) => {
        if (!responseData) return;

        state.NeedAttention = {
          rightEar: false,
          leftEar: false,
          nose: false,
          throat: false,
          neck: false,
          suggestedInvestigation: false,
        };

        // Ear
        const earData = state.EarReportData.clinicalEntExamination;

        Object.keys(earData.rightEar).forEach((key) => {
          const val = responseData[key] === "Y";

          earData.rightEar[key] = val;

          if (val) {
            state.NeedAttention.rightEar = true;
          }
        });

        Object.keys(earData.leftEar).forEach((key) => {
          const val = responseData[key] === "Y";

          earData.leftEar[key] = val;

          if (val) {
            state.NeedAttention.leftEar = true;
          }
        });

        // Meta Data
        Object.keys(state.ENTMetaData).forEach((key) => {
          state.ENTMetaData[key] = responseData[key] || "";
        });

        // Other Data
        Object.keys(state.ENTOtherData).forEach((key) => {
          state.ENTOtherData[key] = responseData[key] || "";
        });

        // Nose
        Object.keys(state.NoseData).forEach((key) => {
          const val = responseData[key] === "Y";

          state.NoseData[key] = val;

          if (val) {
            state.NeedAttention.nose = true;
          }
        });

        // Throat
        Object.keys(state.ThroatData).forEach((key) => {
          const val = responseData[key] === "Y";

          state.ThroatData[key] = val;

          if (val) {
            state.NeedAttention.throat = true;
          }
        });

        // Neck
        Object.keys(state.NeckData).forEach((key) => {
          const val = responseData[key] === "Y";

          state.NeckData[key] = val;

          if (val) {
            state.NeedAttention.neck = true;
          }
        });

        // Suggested Investigation
        Object.keys(state.ENT_Suggested_Investigation_Data).forEach((key) => {
          const val = responseData[key] === "Y";

          state.ENT_Suggested_Investigation_Data[key] = val;

          if (val) {
            state.NeedAttention.suggestedInvestigation = true;
          }
        });
      }),
    ),

  resetENTReport: () =>
    set(() => ({
      ...INITIAL_DATA,
    })),
}));
